import React from 'react'
import { Box } from '@chakra-ui/react'
import { Route, Routes } from 'react-router-dom'
import { Page } from './components/page'
import { MainMenu } from './main-menu'
import { Probe } from './probe/probe'
import { CastMap } from './cast-map/cast-map'

export namespace Layout {
    type Props = {
        onLogout?: () => void
    }

    export const Component = ({ onLogout }: Props) => {
        return (
            <Box w="100vw" h="100vh" display="flex" flexDirection="column">
                <MainMenu onLogout={onLogout} />

                <Box flex="1" overflow="hidden">
                    <Routes>
                        <Route path="/" element={<div>Home</div>} />
                        <Route
                            path="/probe"
                            element={
                                <Page title="Probe">
                                    <Probe />
                                </Page>
                            }
                        />
                        <Route path="/contact" element={<div>Contact</div>} />
                        <Route path="/map" element={<CastMap />} />
                    </Routes>
                </Box>
            </Box>
        )
    }
}
